import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mod modAuth",
  "data-mode": ""
}
const _hoisted_2 = {
  class: "signup",
  "data-referer": "/document/6",
  style: {"display":"block"}
}
const _hoisted_3 = { class: "form" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("nav", { class: "navbar navbar-default header-navigation" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "navbar-header" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "navbar-brand",
      href: "login",
      tabindex: "1"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: "/img/header/logo/logo.png",
        alt: "Logo"
      })
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("header", { class: "" }, null, -1)
const _hoisted_6 = { class: "login-form-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("footer", null, null, -1)
const _hoisted_8 = { class: "login-footer-wrapper" }
const _hoisted_9 = { class: "footer no-padding" }
const _hoisted_10 = { class: "footer__wrapper" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "footer-left col-md-3" }
const _hoisted_13 = { class: "footer-right col-md-9 list list--inline" }
const _hoisted_14 = {
  href: "/page/imprint",
  class: "mis-link"
}
const _hoisted_15 = {
  href: "/page/terms-of-use",
  class: "mis-link"
}
const _hoisted_16 = {
  href: "/page/data-protection",
  class: "mis-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createVNode(_component_Toast),
            _hoisted_7
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("footer", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createElementVNode("p", null, "© " + _toDisplayString(_ctx.year) + " REDKEN", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("footer.imprint")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("footer.terms_of_use")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("footer.data_protection")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "mis-link",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCookieSettings && _ctx.toggleCookieSettings(...args)))
                  }, "Cookie-Einstellungen")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}